import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
} from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";
import camelize from "global/utils/camelize";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  wsGetAllCentrosDemanda,
  wsGetVerificarOsAtencionSinTurno,
  wsPostTomarDemanda,
} from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { hideModal, showModal } from "global/context/action/modal/modal";
import ModalTurnoParticular from "_+_Portal/_-_Autocheckin/components/genericos/ModalTurnoParticular/ModalTurnoParticular";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { setTurnoForced } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import AdvertenciaCentro from "../AdvertenciaCentro/AdvertenciaCentro";
import { DistanciaCentro } from "../PagesFun";

const DemandaEspontanea = ({ setError }) => {
  // -------------------------  useContex  ----------------------------
  const {
    pasoDispatch,
    atencionSinTurnoDispatch,
    turnosSeleccionadosDispatch,
    turnosAutoCheckInDispatch,
    ubicacionState,
  } = useContext(AutocheckContext);
  const { ordenDigitalDispatch } = useContext(PortalContext);
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const coordenadas = ubicacionState?.ubicacion?.data;
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [demandaList, setDemandaList] = useState([]);
  const [loading, setLoading] = useState(true);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("Home")(pasoDispatch);
  };

  const calcularDistancia = (element) => {
    if (DistanciaCentro(coordenadas, element)) {
      tomarTurnoDemanda(element);
    } else {
      advertenciaCentro(element);
    }
  };

  const advertenciaCentro = (turno) => {
    showModal(
      <AdvertenciaCentro
        tomarTurno={() => tomarTurnoDemanda(turno)}
        infoTurno={turno}
      />,
      "Atención",
      () => hideModal()(modalDispatch),
      false,
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const tomarTurnoDemanda = (turno) => {
    let dissmiss = () => {
      hideModal()(modalDispatch);
    };
    let nextStep = (isCorrect, data) => {
      setLoading(true);
      if (isCorrect) {
        if (data?.codigo === 91) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, false, true)}
              mensajeError={data?.mensaje}
              osAlternativa={true}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else if (data?.codigo === 9) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, true, false)}
              mensajeError={data?.mensaje}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else {
          finalizarProyecto(turno);
        }
      } else {
        setLoading(false);
        showToaster(
          {
            texto: data ? data : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    };
    setLoading(true);
    wsGetVerificarOsAtencionSinTurno(
      -1,
      turno.idMedico,
      turno.idEspe,
      nextStep
    )();
  };

  const finalizarProyecto = (turno, particular, osAlternativa) => {
    setLoading(true);
    let dto = {
      // idPaciente: paciente.codigo,
      idMedico: turno.idMedico,
      idEspecialidad: turno.idEspe,
      idCentro: turno.idCentro,
      particular,
      osAlternativa,
    };
    let nextStep = (isCorrect, element) => {
      if (isCorrect && element) {
        if (DistanciaCentro(coordenadas, element)) {
          let turno = {
            idturno: element["idturno"],
            idMedico: element["idMedico"],
            idRecepcion: element["idRecepcion"],
            idCentro: element["idCentro"],
            medico: element["medico"],
            fecha: element["fecha"],
            hora: element["hora"],
            especialidad: element["especialidad"],
            centro: element["centro"],
            checkin: element["checkin"],
            flgSaldada: element["flgSaldada"],
            coordenadaGps: element["coordenadaGps"],
            selected: true,
            idProtocolo: element["idProtocolo"],
            presente: element["presente"],
            consultorio: element["consultorio"],
            flgSoloConsulta: element["flgSoloConsulta"],
            flgSoloPractica: element["flgSoloPractica"],
            ausente: element["ausente"],
            requiereAutorizacion: element["requiereAutorizacion"],
            estadoProtocolo: element["estadoProtocolo"],
            kinesioVerificaRecepcion: element["kinesioVerificaRecepcion"],
            osValidacionInterna: element["osValidacionInterna"],
            idEspecialidad: element["idEspecialidad"],
            resumen: {
              validaOnlineEstado: element["validaOnlineEstado"],
              validaOnline: element["validaOnline"],
              monto: element["monto"],
              medSolicitanteDto: element["medSolicitanteDto"],
              estadoOrden: element["estadoOrden"],
              tieneDeterminaciones: element["tieneDeterminaciones"],
            },
          };
          setTurnosSeleccionado([turno])(turnosSeleccionadosDispatch);
          setTurnoForced([turno])(turnosAutoCheckInDispatch);
          setPaso("Resumen")(pasoDispatch);
        } else {
          setPaso("OtroCentro")(pasoDispatch);
        }
        sessionStorage.removeItem("getOrdenes");
        sessionStorage.removeItem("ordenesList");
      } else {
        setError({
          message: "Error al traer el turno",
          errorBack: "Home",
        });
      }
      setLoading(false);
    };
    wsPostTomarDemanda(dto, nextStep, -1)();
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    let nextStep = (isCorrect, data) => {
      if (isCorrect) {
        setDemandaList(data);
        setLoading(false);
      } else {
        setLoading(false);
        showToaster(
          {
            texto: "Error al obtener turnos",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    };
    wsGetAllCentrosDemanda(nextStep)(atencionSinTurnoDispatch);
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"ATENCIÓN SIN TURNO"}
        subtitle={
          "Elegí la especialidad que necesitás y presioná el botón 'Recepcionarme' para ingresarte."
        }
        minSizeTxt={true}
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              {demandaList?.length > 0 ? (
                demandaList.map((element, index) => {
                  return (
                    <CardOrden key={index}>
                      <p className="header c-white rb18m">
                        {element?.idgrupoestudio_desc === ""
                          ? "Estudio"
                          : camelize(element?.especialidad)}
                      </p>
                      <div className="bodyOrden">
                        <p>
                          Médico:{" "}
                          <span className="rb16m">{element?.profesional}</span>
                        </p>
                        <p>
                          Demora:{" "}
                          <span className="rb16m">{element?.demora}</span>
                        </p>
                        <p>
                          Centro:{" "}
                          <span className="rb16m">{element?.centro}</span>
                        </p>
                        <p>
                          Direccion:{" "}
                          <span className="rb16m">{element?.direccion}</span>
                        </p>
                        <ButtonP5 onClick={() => calcularDistancia(element)}>
                          Recepcionarme
                        </ButtonP5>
                      </div>
                    </CardOrden>
                  );
                })
              ) : (
                <TurnoNoEncontrado
                  state={demandaList}
                  loadingState={loading}
                  recomendacion={"No se encontraron agendas disponibles."}
                />
              )}
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default DemandaEspontanea;
